import { useLocation } from 'react-router-dom';
import StaticCrumb from '../StaticCrumb';

const ORGANIZATIONS_PATH = '/admin/organizations';

const OrganizationsCrumb = () => {
    const location = useLocation();
    const isListPage = location.pathname === ORGANIZATIONS_PATH;

    return (
        <StaticCrumb label="Organizations" href={ORGANIZATIONS_PATH} isCurrentPage={isListPage} />
    );
};

export default OrganizationsCrumb;
